import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';
import { Card, Input } from 'components';
import { State } from 'interfaces/state';

interface Props {
    state: State;
}

export default function AdnuntiusData({ state }: Props) {
    return (
        <>
            <Card>
                <FormGroup row>
                    <Label style={{ textAlign: 'right' }} sm={2}>
                        Folder Id
                    </Label>
                    <Col sm={8}>
                        <Input state={state} name='content.folderId' />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label style={{ textAlign: 'right' }} sm={2}>
                        Keywords
                    </Label>
                    <Col sm={8}>
                        <Input state={state} name='content.keywords' />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label style={{ textAlign: 'right' }} sm={2}>
                        Categories
                    </Label>
                    <Col sm={8}>
                        <Input state={state} name='content.categories' />
                    </Col>
                </FormGroup>
            </Card>
        </>
    );
}
